import React from 'react';
import PropTypes from 'prop-types';
import OutboundLink from '../../../common/OutboundLink';
import { isValid, isText, decodeTags, decodeSpecialCharacters, getFileName, getRelValue } from '../../../../utils';

const ArticleProduct = ({
  product,
  isMobile,
  isContentHub,
}) => {
  if (!isValid(product)) { return null; }
  const {
    imageSrc,
    oldPrice,
    price,
    productTitle,
    productTeaser,
    productDescription,
    sponsored,
    salesSticker,
  } = product;

  let { name, buttonTxt, buttonURL } = product;
  if (!isText(buttonTxt)) {
    buttonTxt = 'Buy Now';
  }
  if (isText(buttonURL)) {
    buttonURL = decodeSpecialCharacters(buttonURL);
  }
  if (isText(name)) {
    name = decodeSpecialCharacters(name);
  }
  const renderedOldPrice = isText(oldPrice) ? `$${oldPrice}` : null;
  const renderedPrice = isText(price) ? `$${price}` : null;
  const renderedPricing = <div className="product-price">{oldPrice && <span className="old-price">{renderedOldPrice}</span>}{oldPrice && <span className="comma-span">;&nbsp;</span>}<span>{renderedPrice}</span></div>;
  const productRel = getRelValue(buttonURL);
  const renderedCopyBuy = isValid(buttonURL) ? (
    <OutboundLink className="product-buy" sponsoredRel={true} href={buttonURL} dataLinkType="shop-link" >
      {buttonTxt}
    </OutboundLink>
  ) : null;
  let titleClass;
  if (isValid(productTitle) && productTitle.length > (isMobile ? 19 : 27)) {
    titleClass = 'wrap';
  } else {
    titleClass = 'nowrap';
  }

  const hasSalesSticker = isText(salesSticker);
  const stickerSrc = 'https://www.purewow.com/static-gmg/purewow/images/on+sale+sticker.webp';
  const renderedSalesSticker = hasSalesSticker ? <img className='sales-sticker' src={stickerSrc} alt='sales sticker' loading='lazy' /> : null;

  return (
    <div className={`article-shoppable-product ${productTitle ? '' : 'no-title'}`}>
      {isValid(productTitle) && <h5 className={titleClass}>{productTitle}</h5>}
      <div className="product-hed">
        <a href={buttonURL} className="product-hed-link" rel={productRel} target="_blank"><h4>{name}</h4></a>
      </div>
      <div className="img-container">
        <a href={buttonURL} className="article-product-img-link article-product-img-wrapper" rel={productRel}  target="_blank" data-link-type="image-link">
          <img className="article-product-img" src={imageSrc} alt={getFileName(imageSrc)} loading="lazy"/>
          {renderedSalesSticker}
        </a>
        {isValid(sponsored) && <span className="sponsored-txt">SPONSORED</span>}
      </div>
      {isValid(productTeaser) && <p className="product-teaser">{productTeaser}</p>}
      {isValid(productDescription) && <p className="product-description">{productDescription}</p>}
      {isValid(renderedPrice) && renderedPricing}
      {renderedCopyBuy}
    </div>
  );
};

ArticleProduct.propTypes = {
  product: PropTypes.object,
  isMobile: PropTypes.bool,
};

export default ArticleProduct;
